import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Google OAuth callback landing page.
 * Server redirects here after a successful Google login:
 *   /auth/callback?token=<access_token>
 * This page picks up the token, stores it in memory, then redirects to the app.
 */
export default function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error || !token) {
      navigate('/auth/login?error=oauth_failed');
      return;
    }

    loginWithToken(token)
      .then((member) => {
        // Remove token from URL immediately
        window.history.replaceState({}, '', '/auth/callback');
        navigate(member?.onboarding_phase === 'observing' ? '/onboarding' : '/dashboard');
      })
      .catch(() => {
        navigate('/auth/login?error=oauth_failed');
      });
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-reset-cream">
      <p className="text-reset-brown text-sm">Signing you in…</p>
    </div>
  );
}
